/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Convert_To_Pop_OnInputs */

const en_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert to Pop-On`)
};

const fr_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir en pop-up`)
};

const de_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Pop-On umstellen`)
};

const it_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti in Pop-On`)
};

const ru_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразовать в Pop-On`)
};

const es_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir a Pop-On`)
};

const zh_cn2_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换为弹出式窗口`)
};

const ja_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポップオンに変換`)
};

const hi_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पॉप-ऑन में बदलें`)
};

const pt_pt2_convert_to_pop_on = /** @type {(inputs: Convert_To_Pop_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter para Pop-On`)
};

/**
* | output |
* | --- |
* | "Convert to Pop-On" |
*
* @param {Convert_To_Pop_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const convert_to_pop_on = /** @type {((inputs?: Convert_To_Pop_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Convert_To_Pop_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_convert_to_pop_on(inputs)
	if (locale === "de") return de_convert_to_pop_on(inputs)
	if (locale === "it") return it_convert_to_pop_on(inputs)
	if (locale === "ru") return ru_convert_to_pop_on(inputs)
	if (locale === "es") return es_convert_to_pop_on(inputs)
	if (locale === "zh-CN") return zh_cn2_convert_to_pop_on(inputs)
	if (locale === "ja") return ja_convert_to_pop_on(inputs)
	if (locale === "hi") return hi_convert_to_pop_on(inputs)
	if (locale === "pt-PT") return pt_pt2_convert_to_pop_on(inputs)
	return en_convert_to_pop_on(inputs)
});